import { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import LoginForm from '../../components/ClubeBaneficios/LoginForm';
import RegisterForm from '../../components/ClubeBaneficios/RegisterForm';

export default function Cadastro(): ReactElement {
  const location = useLocation();
  const navigate = useNavigate();

  const isRegister = location.pathname.endsWith('/registerForm');

  return (
    <div className="flex justify-center items-center bg-gray-50 px-4 p-4 sm:px-6">
      <div className="w-full max-w-4xl sm:max-w-6xl p-8 rounded-2xl shadow-lg sm:p-10">
        {isRegister ? (
          <RegisterForm onSwitchToLogin={() => navigate('/ClubeBeneficios')} />
        ) : (
          <LoginForm
            onSwitchToRegister={() => navigate('/ClubeBeneficios/registerForm')}
          />
        )}
      </div>
    </div>
  );
}
